import React, { useContext, useEffect, useMemo, useState } from "react";
import { Static2Map1Set, Year1Set } from "../App";
import { useDidUpdateEffect } from "../hooks/useDidUpdateEffect";

export const ButtonYears = () => {
  const { static2map1set } = useContext(Static2Map1Set);
  const { year1set, setYear1Set } = useContext(Year1Set);
  const [repeat, setRepeat] = useState(false);

  const years = useMemo(
    () => [
      "year1","year2","year3","year4","year5",
      "year6","year7","year8","year9","year10",
      "year11","year12","year13","year14","year15",
    ],
    []
  );

  // 3000=非表示 + static2map1set に存在する年だけ並べる（元の挙動）
  const year1s = useMemo(() => {
    const arr = [3000];
    if (!static2map1set) return arr;

    years.forEach((k) => {
      const v = static2map1set?.[k];
      if (v) arr.push(v);
    });
    return arr;
  }, [static2map1set, years]);

  // ★ 初期状態で「未選択」に見えないように：最初だけ default を当てる
  useEffect(() => {
    // 既に有効値が入ってるなら何もしない（ユーザー操作を尊重）
    const sv = year1set;
    const isUnset = sv === undefined || sv === null || sv === "" || sv === 0;
    if (!isUnset) return;

    if (!static2map1set) return;

    // 以前どおり「year5 優先」
    const y5 = static2map1set?.year5;

    // 次点：year1s の最初の年（3000以外）
    const firstVisible = year1s.find((v) => v !== 3000);

    const next = y5 || firstVisible || 3000;
    setYear1Set(Number(next));
  }, [static2map1set, year1s, year1set, setYear1Set]);

  const handleChange = (e) => {
    setYear1Set(Number(e.target.value));
    setRepeat(false);
  };

  const handleChangerepeat = () => {
    setRepeat((r) => !r);
  };

  const [timecount, setTimecount] = useState(-1);
  useEffect(() => {
    if (!repeat) return;
    const interval = setInterval(() => {
      setTimecount((c) => c + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [repeat]);

  useDidUpdateEffect(() => {
    setYear1Set(Number(year1s[timecount % year1s.length]));
  }, [timecount]);

  return (
    <>
      <main className="flex md:my-3 md:mx-2 items-center justify-center pointer-events-auto">
        <div className="flex md:rounded-xl bg-gray-200 p-1 md:py-1" x-data="app">
          <div>
            <input
              name="year1repeat"
              id="連続表示"
              type="checkbox"
              onChange={handleChangerepeat}
              checked={true == repeat}
              className="peer hidden"
            />
            <label
              htmlFor="連続表示"
              className="block cursor-pointer select-none md:rounded-xl px-0 md:px-2 py-0 md:py-2 text-center text-xs md:text-xs lg:text-sm peer-checked:bg-blue-500 peer-checked:text-white"
            >
              連続表示
            </label>
          </div>
        </div>

        <div className="flex md:rounded-xl bg-gray-200 p-1 md:py-1" x-data="app">
          {year1s.map((item) => {
            return (
              <div key={item}>
                <input
                  name="year1set"
                  id={item}
                  type="radio"
                  value={item}
                  onChange={handleChange}
                  checked={item == year1set}
                  className="peer hidden"
                />
                {item == 3000 ? (
                  <label
                    htmlFor={item}
                    className="block cursor-pointer select-none md:rounded-xl px-0 md:px-2 py-0 md:py-2 text-center text-xs md:text-xs lg:text-sm peer-checked:bg-blue-500 peer-checked:text-white"
                  >
                    非表示
                  </label>
                ) : (
                  <label
                    htmlFor={item}
                    className="block cursor-pointer select-none md:rounded-xl px-0 md:px-2 py-0 md:py-2 text-center text-xs md:text-xs lg:text-sm peer-checked:bg-blue-500 peer-checked:text-white"
                  >
                    {item}年
                  </label>
                )}
              </div>
            );
          })}
        </div>
      </main>
    </>
  );
};